export const ROUTE_NAMES = {
  HOME: '/',
  COMPANY: '/about-us',
  PROJECTS: '/projects',
  TEAM: '/team',
  BLOG: '/blog',
  PRESS: '/press',
  PRESSSINGLE: '/press/single-page',
  CONTACT: '/contact-us',
  INVEST: '/invest-in-project',
  
  DEVELOPMENTDESIGN: '/development-and-design-services',
  REALESTATEDEVELOPMENT:
    '/development-and-design-services/real-estate-development',
  PREDEVELOPMENTPLANNING:
    '/development-and-design-services/pre-development-planning',
  DESIGNBUILD: '/development-and-design-services/design-build',
  SMARTSUSTAINABLE: '/development-and-design-services/smart-building',

  CAPITALINVESTMENT: '/capital-and-investment-services',
  CAPITALVENTURES: '/capital-and-investment-services/capital-ventures',
  LENDINGSOLUTIONS: '/capital-and-investment-services/lending-solutions',
  EBSERVICE: '/capital-and-investment-services/eb-5',

  ASSETPROPERTY: '/asset-and-property-services',
  ELITEPROPERTYMANAGMENT: '/asset-and-property-services/elite-property-management',

  STARLIFEPLAZA: '/projects/starlife-plaza',
  HOLLYWOOD: '/projects/hollywood',
  RIVERLANDMANSION: '/projects/riverland-mansion',
  RIVERLANDESTATES: '/projects/riverland-estates',
  CORALRIDGEVILLAS: '/projects/coral-ridge-villas',
  CORALRIDGERESIDENCES: '/projects/coral-ridge-residences',
  DANIABEACHVILLAS: '/projects/dania-beach-villas',
};
